<script>
import Vue from 'vue';
import useUsuarioStore from '@/api/v2/stores/UsuarioStore';
import useColaboradorStore from '@/api/v2/stores/ColaboradorStore';
import View from '@/api/v2/View.mjs';
import ItensREService from '@/api/v2/services/ItensREService';
import CreateListEmbView from './CreateListEmbView';

export default {

    //==================================================================//
    //============================== NAME ==============================//
    //==================================================================//
    name: 'ItensRE',

    //==================================================================//
    //========================= COMPONENTES ============================//
    //==================================================================//
    components: {
        CreateListEmbView
    },

    //==================================================================//
    //============================ DATA ================================//
    //==================================================================//
    data() {
        return {

            //==================================================================//
            //========================== STORES ================================//
            //==================================================================//
            usuarioStore: {},
            colaboradorStore: {},

            //==================================================================//
            //====================== Controles Desativados =====================//
            //==================================================================//
            controlesDesativados: false,

            //==================================================================//
            //===================== Gerar Lista de Embarque ====================//
            //==================================================================//
            gerarListaDeEmbarque: false,

            //==================================================================//
            //=========================== Dados ================================//
            //==================================================================//
            dados: [],
            
            //==================================================================//
            //===================== Dados Selecionados =========================//
            //==================================================================//
            dadosSelecionados: [],

            //==================================================================//
            //====================== Tabela de Dados ===========================//
            //==================================================================//
            dadosHeaders: [
                { text: "Job",                      value: "job.code" },
                { text: "OS",                       value: "ordemDeServico.codigo" },
                { text: "Sequência",                value: "sequencia" },
                { text: "Número",                   value: "item.code" },
                { text: "Destino",                  value: "destino"},
                { text: "Descrição",                value: "descricao" },
                { text: "Unidade",                  value: "unidadeSigla" },
                { text: "Quantidade Disponível",    value: "quantidadeParaEmbarcar" },
                { text: "Status",                   value: "status" }
            ],

            //==================================================================//
            //================== Itens Codigos Caldeiraria =====================//
            //==================================================================//
            itemCodigosCaldeiraria: [ "9100000", "9500000" ],

            //==================================================================//
            //=================== Controle de Paginação ========================//
            //==================================================================//
            paginaAtual: 1,
            paginaQuantidade: 0,
            paginaItensPorPagina:0,

            //==================================================================//
            //========================== FILTROS ===============================//
            //==================================================================//
            filter: {
                search: '',
                job: '',
                os: ''
            },

        }
    },

    //==================================================================//
    //============================= METODOS ============================//
    //==================================================================//
    methods: {

        //==================================================================//
        //================= Altera Controles Desativados ===================//
        //==================================================================//
        async alteraControlesDesativados(update) {
            
            this.controlesDesativados = update;

        },

        //==================================================================//
        //========================== Load Itens RE =========================//
        //==================================================================//
        async loadItensRE(){

            let response = await Vue.prototype.$http.post('/View/run', {
                params: [
                    { dataType: "string", name: "descricao", value: this.filter.search },
                    { dataType: "string", name: "osCodigo", value: this.filter.os },
                    { dataType: "string", name: "jobCodigo", value: this.filter.job }
                ],
                viewName: View.ITENS_RE,
                page: this.paginaAtual,
                limit: 30
            });

            this.dados = response.data.data.data;
            this.dadosSelecionados = [];
            this.armazenaPaginacao(response.data.data);

        },

        //==================================================================//
        //================= Fecha Gerar Lista de Embarque ==================//
        //==================================================================//
        async fechaGerarListaDeEmbarque() {
            
            this.gerarListaDeEmbarque = false;
            await this.loadItensRE();

        },

        //==================================================================//
        //================ Mostra Gerar Lista de Embarque ==================//
        //==================================================================//
        async mostraGerarListaDeEmbarque() {
            
            this.gerarListaDeEmbarque = true;

        },

        //==================================================================//
        //================== Retornar para Almoxarifado ====================//
        //==================================================================//
        async retornarParaAlmoxarifado(){

            let ordemDeServicoItensValores = this.dadosSelecionados.map((ordemDeServicoItem)=>{

                return{
                    id: ordemDeServicoItem.id,
                }

            });

            let ordemDeServicoItens = await ItensREService.retornarParaAlmoxarifado(ordemDeServicoItensValores);
            if(ordemDeServicoItens.status != 200){
                throw new Error("Falha ao Retornar os Itens para Almoxarifado.");
            }

            await this.loadItensRE();

        },

        //==================================================================//
        //=================== Dar Baixa para Entregue ======================//
        //==================================================================//
        async darBaixaParaEntregue(){

            let ordemDeServicoItensValores = this.dadosSelecionados.map((ordemDeServicoItem)=>{

                return{
                    id: ordemDeServicoItem.id,
                }

            });

            let ordemDeServicoItens = await ItensREService.darBaixaParaEntregue(ordemDeServicoItensValores);
            if(ordemDeServicoItens.status != 200){
                throw new Error("Falha ao Dar Baixa nos Itens para Entregue.");
            }

            await this.loadItensRE();

        },

        //==================================================================//
        //=================== Armazena Paginacao ===========================//
        //==================================================================//
        async armazenaPaginacao(dadosPaginacao) {
            
            this.paginaQuantidade = dadosPaginacao.pages;
            this.paginaItensPorPagina = dadosPaginacao.limit;

        },

        //==================================================================//
        //========================= Ao Paginar =============================//
        //==================================================================//
        async aoPaginar(paginaNumero) {
            this.paginaAtual = paginaNumero
            await this.loadItensRE()
        },

    },

    async created(){

            //==================================================================//
            //=========================== User Store ===========================//
            //==================================================================//

            this.usuarioStore = useUsuarioStore();

            //==================================================================//
            //======================== Colaborador Store =======================//
            //==================================================================//

            this.colaboradorStore = useColaboradorStore(); 

            //==================================================================//
            //================ Pega Itens de Ordem de Serviço RE ===============//
            //==================================================================//

            await this.loadItensRE();

    },

}
</script>

<template>

    <div>

        <h2>OS Itens (RE)</h2>

        <div class="d-flex w-100 gap-10 search-form">

            <form class="w-100 flex-grow-1 d-flex justify-center align-baseline" @submit.prevent="loadItensRE">

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field
                        cols="6"
                        class="pt-5 pb-5"
                        chips
                        v-model="filter.search"
                        clearable
                        hide-details
                        hide-selected
                        prepend-icon="mdi-magnify"
                        label="Item"
                        solo
                    />
                
                    <v-text-field 
                        v-model="filter.os"
                        cols="6"
                        class="pt-5 pb-5"
                        type="text" 
                        label="OS"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        solo
                    ></v-text-field>
                            
                    <v-text-field 
                        v-model="filter.job"
                        cols="6"
                        class="pt-5 pb-5"
                        type="text" 
                        label="JOB"
                        chips
                        clearable
                        hide-details
                        hide-selected
                        solo
                    ></v-text-field>
                    
                    <v-btn type="submit" color="primary" large class="mt-5">Buscar</v-btn>

                </v-row>

            </form>

            <div class="text-center">

                <v-menu>

                    <template v-slot:activator="{ on }">

                        <v-btn
                            color="primary"
                            v-on="on" 
                            large
                            :disabled="dadosSelecionados.length == 0"
                        >
                            Ações em Massa...
                        </v-btn>

                    </template>

                    <v-list>

                        <v-list-item
                            class="cursor-pointer"
                            @click="mostraGerarListaDeEmbarque"
                        >
                            
                        <v-list-item-title>Gerar Lista de Embarque</v-list-item-title>

                        </v-list-item>

                        <v-list-item
                            class="cursor-pointer"
                            @click="retornarParaAlmoxarifado"
                        >
                            
                        <v-list-item-title>Retornar Para Almoxarifado</v-list-item-title>

                        </v-list-item>

                        <v-list-item
                            class="cursor-pointer"
                            @click="darBaixaParaEntregue"
                        >
                            
                            <v-list-item-title>Dar Baixa Para Entregue</v-list-item-title>

                        </v-list-item>

                    </v-list>

                </v-menu>

            </div>

        </div>
        
        <v-data-table
            v-model="dadosSelecionados"
            :headers="dadosHeaders"
            :items="dados"
            class="elevation-1 mt-10"
            disable-sort
            hide-default-footer
            :page.sync="paginaAtual"
            item-value="name"
            show-select            
            :items-per-page="paginaItensPorPagina"
            @page-count="paginaQuantidade = $event"
            return-object
        >

            <!-- Desliga a Capacidade de Selecionar Todos os Itens RE -->
            <template v-slot:[`header.data-table-select`]="{}"></template>
            
            <template v-slot:header:[`data-table-select`]>

                <v-checkbox disabled />

            </template>
            
            <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">

                <v-tooltip right>

                    <template v-slot:activator="{ on, attrs }">

                        <div v-on="on" v-bind="attrs" style="display: flex; justify-content: center;">
                            <v-checkbox
                            :input-value="isSelected"
                            @click.stop="select(!isSelected)"
                            :disabled="dadosSelecionados.some(s => s?.ordemDeServico?.codigo !== item?.ordemDeServico?.codigo) || item.destino == 'ND'"
                            />
                        </div>

                    </template>

                    <span class="bg-deep-purple text-white px-2 py-1 rounded">
                        {{
                            dadosSelecionados.some(s => s?.ordemDeServico?.codigo !== item?.ordemDeServico?.codigo)
                            ? 'Não pode selecionar os diferentes' 
                            : item.destino == 'ND' ? 'Não pode selecionar item sem destino' 
                            : 'Clique para selecionar este item'
                        }}
                    </span>

                </v-tooltip>

            </template>

        </v-data-table>
        
        <div class="text-center pt-2">

            <v-pagination
                v-model="paginaAtual"
                :length="paginaQuantidade"
                @input="aoPaginar"
            ></v-pagination>

        </div>

        <CreateListEmbView
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :controlesDesativados="controlesDesativados"
            :gerarListaDeEmbarque="gerarListaDeEmbarque"
            :dadosSelecionados="dadosSelecionados"
            :itemCodigosCaldeiraria="itemCodigosCaldeiraria"
            @fechaGerarListaDeEmbarque="fechaGerarListaDeEmbarque"
            @alteraControlesDesativados="alteraControlesDesativados"

        />

    </div>

</template>

<style scoped>

    .container {
        width: '100%'
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }
    
</style>